//////////////////
// IMPORTS
//////////////////
import * as React from "react";
import { Provider } from "react-redux";
import IRoot from "./root.d";
import { ConnectedRouter } from "../../routing/connected-router";
import { resolver } from "found";
import { ApolloProvider } from "@apollo/client";
import { client } from "@src/network/apollo-network";
import { track, TrackingContext } from "@clockwise/web-commons/src/util/analytics.util";

//////////////////
// COMPONENT
//////////////////
// This gives us a single component that our entire app is contained under,
// allowing us to wrap the whole app very easily; e.g. for hot-loading
const RootModern = (props: IRoot.Props) => {
  return (
    <TrackingContext.Provider value={track}>
      <Provider store={props.reduxStore}>
        <ApolloProvider client={client}>
          <ConnectedRouter resolver={resolver} />
        </ApolloProvider>
      </Provider>
    </TrackingContext.Provider>
  );
};

export default RootModern;
